<mat-icon
  #icon
  style="width: 100%; height: 100%"
  [svgIcon]="svgIcon"
  [color]="color"
></mat-icon>
